import React from "react";
import Loader from "../../../../../../components/Loader";
import HistoryItem from "./HistoryItem";
import { useDetailHistoryItems } from "./hooks/useDetailHistoryItems";

function History({ cardId }) {
  const { isLoading, sortedHistory } = useDetailHistoryItems(cardId);
  
  return (
    <>
      {isLoading ? (
        <div className="loader-center">
        <Loader color={"black"} />
        </div>
      ) : (
        <>
          <div>
            {sortedHistory?.map((el, index) => (
              <HistoryItem key={`historys-${index}`} history={el} />
            ))}
          </div>
        </>
      )}
    </>
  );
}

export default React.memo(History);
